module.exports = __webpack_public_path__ + "static/media/cup-main.e3c9c8b7.svg";